import React from 'react';
import styles from './index.module.scss';

const CertifiedDispersionBadge = () => <span className={styles.badge}>D</span>;

export default CertifiedDispersionBadge;
